import { IPictoTextRow, IItem } from './types';
import { RichText } from 'prismic-reactjs';
import LazyImage from '@monofront/design-system/components/LazyImage';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapPictoTextRow } from './mapPictoTextRow';

const PictoTextRow: React.FC<IPictoTextRow> = ({ items }) => {
  return (
    <section>
      {items.map((item: IItem, index: number) => {
        return (
          <div key={index} className="container">
            <div className="image-container">
              <LazyImage src={item.image} alt={item.alt} />
            </div>
            <RichText
              render={item.text}
              serializeHyperlink={CustomPrismicLink}
            />
          </div>
        );
      })}
      <style jsx>{`
        .container :global(p) {
          padding-top: 15px;
        }

        .container {
          margin-top: 80px;
          padding: 0 24px 50px 24px;
          text-align: center;
          background-color: white;
        }

        .container :global(p > a) {
          color: var(--clr-tertiary-1);
          text-decoration: underline;
        }

        .image-container {
          transform: translateX(-50%);
          position: relative;
          top: -32px;
          left: 50%;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: white;
        }

        .image-container :global(img) {
          transform: translate(-50%, -50%);
          position: absolute;
          top: 50%;
          left: 50%;
          width: 50%;
        }
      `}</style>
    </section>
  );
};

export default withSlice(PictoTextRow, mapPictoTextRow);
